import { Injectable, inject } from '@angular/core';
import {
    UserPositionDto,
    UserPositionExitCleanupTask,
} from '@pf/platform-core/domain';
import { ReplenishmentDataService } from '@pf/platform-wms/domain';
import { asArraySafe } from '@pf/shared-utility';
import { Observable, of } from 'rxjs';
import { ReplenishmentContext } from '../../models/replenishment-context.model';
import { CpwUserPositionTypes } from '../../UserPositionTypes';

type ReplenishmentContextWithWarehouse = ReplenishmentContext & {
    warehouseId?: string;
};

@Injectable({ providedIn: 'root' })
export class ReplenishmentsPositionExitCleanupTask
    implements UserPositionExitCleanupTask
{
    readonly id = 'replenishments-unclaim';

    private readonly replenishmentDataService = inject(
        ReplenishmentDataService
    );

    appliesTo(position: UserPositionDto): boolean {
        if (
            position.userPositionTypeName !==
            CpwUserPositionTypes.Replenishments
        ) {
            return false;
        }
        const ctx = position.context as
            | ReplenishmentContextWithWarehouse
            | undefined;
        return (
            !!asArraySafe(ctx?.replenishmentIds).length && !!ctx?.warehouseId
        );
    }

    cleanup$(position: UserPositionDto): Observable<unknown> {
        const ctx = position.context as
            | ReplenishmentContextWithWarehouse
            | undefined;
        const warehouseId = ctx?.warehouseId;
        const replenishmentIds = asArraySafe(ctx?.replenishmentIds);
        if (!warehouseId || !replenishmentIds.length) return of(null);
        return this.replenishmentDataService.unClaimReplenishments$(
            warehouseId,
            replenishmentIds
        );
    }
}
